import React, { useEffect, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FaKey, FaCheck, FaClock, FaTimes } from 'react-icons/fa';
import { getCourseCodesStats } from '../../services/courseService';
import { Course } from '../../types';

interface CourseCodesStatsProps {
  courseId: string;
  course?: Course;
}

interface CodesStats {
  total: number;
  used: number;
  expired: number;
  available: number;
}

const CourseCodesStats: React.FC<CourseCodesStatsProps> = ({ courseId, course }) => {
  const [stats, setStats] = useState<CodesStats>({
    total: 0,
    used: 0,
    expired: 0,
    available: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadStats = async () => {
      try {
        setLoading(true);
        setError(null);
        const id = courseId || (course ? course.id : '');
        if (!id) {
          throw new Error('معرف الكورس غير متوفر');
        }
        const data = await getCourseCodesStats(id);
        setStats(data);
      } catch (error) {
        console.error('Error loading course codes stats:', error);
        setError('حدث خطأ أثناء تحميل إحصائيات الأكواد');
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, [courseId, course]);

  if (loading) {
    return <div className="text-center py-3">جاري التحميل...</div>;
  }

  if (error) {
    return <div className="text-danger">{error}</div>;
  }

  return (
    <Row className="g-3">
      <Col xs={12} sm={6} md={3}>
        <Card className="h-100 shadow-sm">
          <Card.Body className="d-flex align-items-center">
            <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
              <FaKey className="text-primary" size={24} />
            </div>
            <div>
              <h6 className="mb-0">إجمالي الأكواد</h6>
              <h3 className="mb-0">{stats.total}</h3>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <Card className="h-100 shadow-sm">
          <Card.Body className="d-flex align-items-center">
            <div className="rounded-circle bg-success bg-opacity-10 p-3 me-3">
              <FaCheck className="text-success" size={24} />
            </div>
            <div>
              <h6 className="mb-0">الأكواد المتاحة</h6>
              <h3 className="mb-0">{stats.available}</h3>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <Card className="h-100 shadow-sm">
          <Card.Body className="d-flex align-items-center">
            <div className="rounded-circle bg-warning bg-opacity-10 p-3 me-3">
              <FaCheck className="text-warning" size={24} />
            </div>
            <div>
              <h6 className="mb-0">الأكواد المستخدمة</h6>
              <h3 className="mb-0">{stats.used}</h3>
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={12} sm={6} md={3}>
        <Card className="h-100 shadow-sm">
          <Card.Body className="d-flex align-items-center">
            <div className="rounded-circle bg-danger bg-opacity-10 p-3 me-3">
              <FaTimes className="text-danger" size={24} />
            </div>
            <div>
              <h6 className="mb-0">الأكواد المنتهية</h6>
              <h3 className="mb-0">{stats.expired}</h3>
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default CourseCodesStats;
